import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import {
  ChartBarHorizontalCustom,
  Legend,
  LoaderWrapper,
  ReportHeading,
  ProgressionWrapper,
  ProgressionFilters,
  ReportOuterWrapper,
  MuiMultiSelect,
  CustomTabs
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { getObjectAsArray, exportExcel_addPercentage } from '../../../../util'
import { LEGEND_COLOR_MAP_NEW, GRAPH_COLOR_PALLET_V2, GRAPH_COLOR_PALLET_V2_TEXT, GRAPH_COLOR_PALLET4 } from '../../../../constants'
import BuyerTable from './buyerTable'
import { ProgressionWrapper as ProgressWrapper } from '../reportCustomTable/style'
import { useGlobalStore } from '../../../../store'
import ProgressionBuyerTable from '../reportSegmentProgression/progressionBuyerTable'
import {SegmentProgressionContent} from '../reportSegmentProgression/segmentProgression'

import {
  RootWrap,
  TabSection1,
  TabSection2,
  ProgressionFiltersWrapper,
  BrandHealthSection,
  HeadingSection,
  ContentSection,
  ChartRow,
  RowName,
  LegendWrap,
  MultiSelectWrapper
} from './style'
import GraphGridTab from '../comparisonViewDeepDiveNew/graphGridTab'
import { Table } from '../comparisonViewDeepDiveNew/graphGridTab'
import { IconListBtn } from '../../../../assets/images/icons'

const SegmentComparison = (props) => {
  const [show , setShow] = useState('graph')
  const [state, setState] = useState([])
  const [stateProgression, setStateProgression] = useState([])
  const [loading, setLoading] = useState(false)
  const [reportExcelData, setReportExcelData] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [checkBoxData , setCheckboxData] = useState([]);
  const [segmentData, setSegmentData] = useState([]);
  const [segmentValues , setSegmentValues] = useState([]);
  const [driversData, setDriversData] = useState([]);
  const [periodsData, setPeriodsData] = useState([]);
  const [periodsValues , setPeriodsValues] = useState([]);
  const [filterValue, setFilterValues] = useState([]);
  const [filterDriversValue, setFilterDriversValues] = useState([]);
  const [filterPeriodsValue, setFilterPeriodsValues] = useState([]);
  const [pptData, setPptData] = useState({});
  const [allValuesShow , setAllValuesShow] = useState(true);
  const [allProgressionValuesShow , setAllProgressionValuesShow] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [stateValue, setStateValue] = useState([])
  
  const {isPPTModalActive} = useGlobalStore()

  const [progressionDataL1Filtered, setProgressionDataL1Filtered] = useState({
    drivers: [],
    periods: [],
  })
  const [progressionDataFiltered, setProgressionDataFiltered] = useState({
    drivers: [],
    periods: [],
  })
  const [configTab, setConfigTab] = useState([])
  const [progressionData, setProgressionData] = useState()
  const [eventCount, setEventCount] = useState(1)
  const [showComparison, setShowComparison] = useState('graph')
  const [pageFlag, setPageFlag] = useState(false)

  let scoreImageryTypeArray = {}
  let scoreImageryTypeArrayL2 = {}
  const filterDataObj = { drivers: [], periods: [] }

  const hasTabs = props.InsightsElementType === 'SegmentOfSegmentOverviewAndProgression'
  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: hasTabs
        ? ReportsService.getSegmentOfSegmentProgressionElement
        : ReportsService.getSegmentOfSegmentOverviewElement,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)
  const colorArray = [...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT, ...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]

  const generateBuyerMaturityData = async (resp, hasTabs) => {
    scoreImageryTypeArray = {}
    scoreImageryTypeArrayL2 = {}

    const rowArrayDataFunc = (data, dataObj) => {
      filterDataObj.periods.push(dataObj?.title || '')
      filterDataObj.drivers.push(data.map((d) => d.PrimarySegmentName))
      return data
    }

    const configTabObject = hasTabs
      ? resp.map((d, i) => {
          return {
            periodInsightsElementId: d.PeriodInsightsElementId,
            id: i,
            label: i === 0 ? d.PeriodName : 'Progression',
            tutorial: i === 0 ? 'CurrentPeriod' : 'Progression',
            title: d.PeriodName,
            periodOrder: d.PeriodOrder,
            data: getObjectAsArray(
              d?.SegmentOfSegmentOverviewElements?.SegmentOfSegmentOverviewElement || []
            ), // .map(f => ({ ...f, EntityType: f.Entity.EntityType })).filter(f => f.EntityType !== 'HiddenBrand' )
          }
        })
      : []

    const rowArrayData = hasTabs
      ? configTabObject.map((d) => {
          d.data = rowArrayDataFunc(d.data, d)
          return d
        })
      : [rowArrayDataFunc(resp, null)]

    const rowArray = hasTabs ? rowArrayData[0].data : rowArrayData[0]

    const removeUsingSet = (arr) => {
      let outputArray = Array.from(new Set(arr))
      return outputArray
    }
    const progressionDataL1FilteredData = {
      drivers: removeUsingSet(filterDataObj.drivers.flat(1)),
      periods: removeUsingSet(filterDataObj.periods),
    }
    setProgressionDataL1Filtered(progressionDataL1FilteredData)
    if(driversData?.length === 0) {
      setDriversData(progressionDataL1FilteredData.drivers)
      setFilterDriversValues(progressionDataL1FilteredData.drivers)
    }
    if(periodsData?.length === 0) {
      setPeriodsData(progressionDataL1FilteredData.periods)
      setFilterPeriodsValues(progressionDataL1FilteredData.periods)
    }

    const loadTab1Func = (paramData) => {
      let data = paramData?.map((elem) => {
        return {
          ...elem,
          SecondarySegmentSet: {
            ...elem.SecondarySegmentSet,
            SecondarySegment: getObjectAsArray(elem?.SecondarySegmentSet?.SecondarySegment).map((obj, ind) => ({
              ...obj,
              segmentIndex: ind,
              color: colorArray[ind],
              show: true
            }))
          }
        };
      });
      let dataProgression = paramData?.map((elem) => {
        return {
          ...elem,
          show: true,
          PeriodName: elem.PrimarySegmentName,
          SecondarySegmentSet: {
            ...elem.SecondarySegmentSet,
            SecondarySegment: getObjectAsArray(elem?.SecondarySegmentSet?.SecondarySegment).map((obj, i) => ({
              ...obj,
              color: colorArray[i],
              segmentIndex: i,
              show: true
            }))
          }
        };
      });

      setPptData({content: data});
      setState(data)
      setStateProgression(dataProgression)
      setStateValue(data)
      
      for (let i of getObjectAsArray(paramData[0]?.SecondarySegmentSet?.SecondarySegment)) {
        setCheckboxData(prev => [...prev, i?.SegmentName]);
      }

      for (let i of paramData) {
        setSegmentData((prev) => [...prev, i?.PrimarySegmentName])
      }

      const reportExcelDataObj = []
      for (let i = 0; i < paramData.length; i++) {
        const segmentSet = getObjectAsArray(
          paramData[i]?.SecondarySegmentSet?.SecondarySegment || []
        )
        for (let j = 0; j < segmentSet.length; j++) {
          reportExcelDataObj.push([
            { value: paramData[i].PrimarySegmentName },
            { value: segmentSet[j].SegmentName },
            exportExcel_addPercentage(segmentSet[j].SegmentValue),
          ])
        }
      }
      setReportExcelData(reportExcelDataObj)
    }

    if (hasTabs) {
      setConfigTab(configTabObject.filter(f => f.id<2))

      const finalData = {
        sentimentSplit: [],
        sentimentSplitTemp: [],
        categorySentimentSplit: [],
        legendData: [],
      }

      for (let i = 0; i < rowArrayData.length; i++) {
        const d0 = rowArrayData[i].data

        for (let j = 0; j < d0.length; j++) {
          const d1 = d0[j]
          const obj = {
            title: rowArrayData[i].title,
            name: d1.PrimarySegmentName,
          }

          const arr = getObjectAsArray(d1.SecondarySegmentSet.SecondarySegment)
          for (let k = 0; k < arr.length; k++) {
            if (!finalData.legendData.includes(arr[k].SegmentName)) {
              finalData.legendData.push(arr[k].SegmentName)
            }
            obj[arr[k].SegmentName.trim().replaceAll(' ', '')] = arr[k].SegmentValue
          }

          finalData.sentimentSplitTemp.push(obj)
        }
      }

      finalData.legendData = finalData.legendData.map((d, i) => ({ label: d, value: i }))

      for (let m = 0; m < progressionDataL1FilteredData.drivers.length; m++) {
        const m1 = progressionDataL1FilteredData.drivers[m]
        const m2 = finalData.sentimentSplitTemp.filter((f) => f.name === m1)
        finalData.sentimentSplit.push(m2)
      }

      loadTab1Func(rowArrayData[0].data)

      setProgressionData(finalData)
    } else {
      loadTab1Func(resp)
    }

    setLoading(false)
    setEventCount((p) => p + 1)
    setTimeout(() => {
      updateSubLhsApiLoaded(props)
    }, 2000)
  }

  const filterChangeFunc = (selectedValue) => {
    setAllValuesShow(prev => selectedValue.length > 0 ? true : false);
    const selectedValues = selectedValue.filter((val) => val !== 'All');
    
    let data = state?.map((elem) => {
      return {
        ...elem,
        SecondarySegmentSet: {
          ...elem.SecondarySegmentSet,
          SecondarySegment: getObjectAsArray(elem?.SecondarySegmentSet?.SecondarySegment).map((obj) => ({
            ...obj,
            show: selectedValues.includes(obj.SegmentName)
          }))
        }
      };
    });

    setState(data);
    setFilterValues(selectedValue);
  };

  const filterChangeDriversFunc = (selectedVal) => {
    const selectedValue = selectedVal?.Drivers ? selectedVal.Drivers : selectedVal

    setAllProgressionValuesShow(prev => selectedValue.length > 0 ? true : false);
    const selectedProgressionValues = selectedValue.filter((val) => val !== 'All');

    let dataProgression = stateProgression?.map((elem) => {
      return {
        ...elem,
        show: true,
        PeriodName: elem.PrimarySegmentName,
        SecondarySegmentSet: {
          ...elem.SecondarySegmentSet,
          SecondarySegment: getObjectAsArray(elem?.SecondarySegmentSet?.SecondarySegment).map((obj, i) => ({
            ...obj,
            segmentIndex: i,
            show: selectedProgressionValues.includes(obj.PrimarySegmentName)
          }))
        }
      };
    });

    setStateProgression(dataProgression);
    setFilterDriversValues(selectedValue);
  };

  const filterPeriodsChangeFunc = (selectedVal) => {
    const selectedValue = selectedVal // selectedVal?.Drivers ? selectedVal.Drivers : selectedVal
    setAllValuesShow(prev => selectedValue.length > 0 ? true : false);
    const selectedValues = selectedValue.filter((val) => val !== 'All');

    let data = state?.map((elem) => {
      return {
        ...elem,
        show: selectedValues.includes(elem.PrimarySegmentName)
      }
    })

    setStateProgression(data);
    setFilterPeriodsValues(selectedValue);
  };

  const onSuccessFunc = (resp) => {
    generateBuyerMaturityData(resp, hasTabs)
  }

  const onBtnClick = (activeTab) => {
    setShow(activeTab);
  }

  const onCompareBtnClick = (activeTab) => {
    setShowComparison(activeTab);
  } 

  // Conversion function
  const convertSmallToBig = (smallData) => {
      // 1️⃣ Collect all possible store keys across all entries
      const allStoreKeys = [
        ...new Set(
          smallData.flatMap(obj =>
            Object.keys(obj).filter(k => !["title", "name"].includes(k))
          )
        )
      ];

      // 2️⃣ Convert to Big format
      const hasData = {}
      const arr = smallData.map(entry => {
        const secondarySegments = allStoreKeys.map((key, idx) => {
          const obj = {
            SegmentName: key.replace(/([a-z])([A-Z0-9])/g, '$1 $2').replace(/\s+/g, ' ').trim(),
            SegmentValue: entry[key] ?? 0,
            segmentIndex: idx,
            color: colorArray[idx],
            show: true
          }
          if(hasData?.[obj.SegmentName]){
            hasData[obj.SegmentName] = hasData[obj.SegmentName] + (entry[key] ?? 0)
          } else {
            hasData[obj.SegmentName] = (entry[key] ?? 0)
          }
          return obj
        });

        return {
          PrimarySegmentName: entry.title,
          PrimarySegmentValue: 100,
          SecondarySegmentSet: { SecondarySegment: secondarySegments },
          show: true,
          PeriodName: entry.name
        };
      });

      function getKeysByValue(obj, targetValue) {
        return Object.keys(obj).filter(key => obj[key] === targetValue);
      }

      const keysWithZero = getKeysByValue(hasData, 0);
      const arr2 = arr

      const cleanedData = arr2.map(item => {
      const filteredSecondary = item.SecondarySegmentSet.SecondarySegment.filter(
        seg => !keysWithZero.includes(seg.SegmentName)
      );
      return {
        ...item,
        SecondarySegmentSet: {
          SecondarySegment: filteredSecondary
        }
      };
    });

    return cleanedData
  }
  
  useEffect(() => {
    if(activeTab===0) filterChangeFunc(checkBoxData);
    if(activeTab===1) {
      // filterChangeDriversFunc(drivers);
    }
  }, [checkBoxData, activeTab, driversData])

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  return (
    <>
      {reportExcelData && (
        <ReportHeading
          resetInsightHeight={eventCount}
          downloadId={props.type}
          pptData={pptData}
          {...props}
          downloadIdData={reportExcelData}
        />
      )}
      <ReportOuterWrapper>
        <RootWrap id={props.type}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            <CustomTabs
              options={configTab}
              onChange={e => {setActiveTab(e); setEventCount((p) => p + 1);}}
              value={activeTab}
              styletype='themeV2'
            />
            {activeTab === 0 && <>
              {state.length && (
                <>
                  <ProgressWrapper>
                    {checkBoxData.length > 0 && (
                      <MuiMultiSelect
                        name={checkBoxData.length}
                        placeholder={`Select Category/Brand`}
                        onChange={(val) => filterChangeFunc(val)}
                        onSelectAll={(val) => {
                          const newVal = val ? checkBoxData : [];
                          filterChangeFunc(newVal);
                        }}
                        data={checkBoxData}
                        value={filterValue}
                        // style={{ width: '24%' }}
                        style={{ width: '100%', maxWidth: '200px' }}
                        search={true}
                      />
                    )}
                    <GraphGridTab onClick={onBtnClick} show={show} GraphIcon={Table} TableIcon={IconListBtn} disableActiveBg={true} />
                  </ProgressWrapper>

                  <BuyerTable
                    view={show}
                    isExtraColor={props.isExtraColor}
                    data={state}
                    colorPallet={[...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT , ...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]}
                    sortedPieColorObject={[...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT , ...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]}
                    showLegendToolTip={true}
                    allValuesShow={allValuesShow}
                  />
                </>
              )}
            </>}
            {activeTab === 1 && <>
              {stateProgression.length > 0 && <ProgressWrapper>
                <MultiSelectWrapper>
                {driversData.length > 0 && (
                    <MuiMultiSelect
                      name={driversData.length}
                      placeholder={`Select Drivers`}
                      onChange={(val) => filterChangeDriversFunc(val)}
                      onSelectAll={(val) => {
                        const newVal = val ? driversData : [];
                        filterChangeDriversFunc(newVal);
                      }}
                      data={driversData}
                      value={filterDriversValue}
                      style={{ width: '100%', maxWidth: '200px', marginRight: '8px' }}
                      search={true}
                    />
                  )
                }
                {periodsData.length > 0 && (
                    <MuiMultiSelect
                      name={periodsData.length}
                      placeholder={`Select Period`}
                      onChange={(val) => filterPeriodsChangeFunc(val)}
                      onSelectAll={(val) => {
                        const newVal = val ? periodsData : [];
                        filterPeriodsChangeFunc(newVal);
                      }}
                      data={periodsData}
                      value={filterPeriodsValue}
                      style={{ width: '100%', maxWidth: '200px' }}
                      search={true}
                    />
                  )
                }
                </MultiSelectWrapper>
                <GraphGridTab onClick={onCompareBtnClick} show={showComparison} GraphIcon={Table} TableIcon={IconListBtn} disableActiveBg={true} />
              </ProgressWrapper>}

              {filterPeriodsValue?.length>0 && filterDriversValue?.length>0 && progressionData?.sentimentSplit.map((d, i) => {
                const d1 = convertSmallToBig(d).filter(f => filterPeriodsValue.includes(f.PrimarySegmentName));
                
                if (!filterDriversValue?.includes(d1[0].PeriodName)) {
                  return false
                }
                const progressionData = d1 || []
                
                return (
                  <BrandHealthSections
                    key={i}
                    heading={d[0].name}
                    className='segmentOfSegmentOverviewRowProgression'
                  >
                    {progressionData?.length > 0 && <ProgressionBuyerTable
                      view={showComparison}
                      isExtraColor={true}
                      data={progressionData}
                      colorPallet={[...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]}
                      showLegendToolTip={true}
                      allValuesShow={allProgressionValuesShow}
                      insightsElementType={props.InsightsElementType}
                    />}
                  </BrandHealthSections>
                )
              })}
            </>}

          </LoaderWrapper>
        </RootWrap>
      </ReportOuterWrapper>
    </>
  )
}

export default SegmentComparison

const BrandHealthSections = ({ heading, className, children }) => {
  return (
    <BrandHealthSection className={className}>
      <HeadingSection className='heading'>{heading}</HeadingSection>
      <ContentSection>{children}</ContentSection>
    </BrandHealthSection>
  )
}
